<template>
  <div class="loginContainer">
    <img
      src="../../assets/icon_back.png"
      style="width:4rem;height:4rem;position:fixed;top:0;left:3rem;cursor: pointer;"
      @click="$router.back()"
    />
    <div style="height:3.5rem"></div>
    <div class="studentContainer">
      <div
        style="width:100%;height:100%;background:#ffffff;border-radius:2rem;"
      >
        <div
          style="height:4rem;width:100%;text-align:center;line-height:4rem;position:relative;background: #CFEEFF;border-radius: 2rem 2rem 0px 0px;font-size: 2rem;color: #0F85DB;"
        >
          {{ decodeURIComponent($route.query.nickname) }}的练习
        </div>
        <div
          v-if="students.length > 0 && loaded"
          style="height:calc( 100% - 4rem );border-radius:2rem;overflow:scroll"
          ref="bScroll"
          class="bScroll"
        >
          <div
            style="padding:1rem;display: grid;grid-template-columns: 1fr 1fr 1fr;grid-column-gap: 1rem;grid-row-gap: 1rem;"
            ref="scrollContainer"
          >
            <div
              v-for="(item, index) in students"
              :key="index"
              style="position: relative; width:100%;border-radius:1rem;cursor: pointer;"
              @click="picMarkShow(item.pic, index)"
            >
              <img v-lazy="item.pic" style="width:100%;border-radius:1rem;" />
              <img
                v-if="item.recommended == '1'"
                src="../../assets/recommended.png"
                style="width: 8.2rem;height: 5.8rem;position: absolute;top:-1rem;right: -1rem"
              />
            </div>
          </div>
        </div>
        <div
          v-if="students.length <= 0 && loaded"
          style="height:calc( 100% - 4rem );border-radius:2rem;overflow:hidden"
          class="flexCenter"
        >
          <div
            style="width:32rem;height:31rem;font-size:1.4rem;color:#0F85DB;position:relative;overflow:hidden;margin-top:11rem"
          >
            <img src="../../assets/task_nodata.png" style="width:100%;" />
            <div
              style="position:absolute;width:100%;height:100%;top:0;left:0"
              class="flexCenter"
            >
              暂无练习
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottom-bar></bottom-bar>
    <div
      style="width:50%;position:fixed;bottom:2.6rem;left:25%"
      class="flexCenter"
    >
      <div>
        <img
          src="../../assets/class_arrow_up.png"
          style="width:3.6rem"
          @click="scrollPrev('bScroll')"
        />
        <img
          src="../../assets/class_arrow_down.png"
          style="width:3.6rem;margin-left:2.5rem"
          @click="scrollNext('bScroll')"
        />
      </div>
    </div>
    <!--    <div style="position:fixed;bottom:4.4rem;right:0.1rem;cursor: pointer;" @click="$router.push('/start_class?class_id='+$route.query.class_id)">-->
    <!--      <img src="../../assets/icon_start_class.png" style="width:7.15rem" />-->
    <!--    </div>-->
    <pic-mark
      ref="pic-mark"
      @prev-page="prevPage"
      @next-page="nextPage"
    ></pic-mark>
  </div>
</template>

<script>
import BottomBar from '../../components/BottomBar.vue'
import PicMark from '../../components/PicMark.vue'
export default {
  name: 'TaskList',
  components: {
    BottomBar,
    PicMark,
  },
  data() {
    return {
      scrollOffset: 0,
      sutdent_name: '',
      students: [],
      loaded: false,
    }
  },
  mounted() {
    this.initData()
  },
  destroyed() {},
  methods: {
    prevPage(idx) {
      if (idx == 0) return
      let newIdx = idx - 1
      this.picMarkShow(this.students[newIdx].pic, newIdx)
    },
    nextPage(idx) {
      if (idx == this.students.length - 1) return
      let newIdx = idx + 1
      this.picMarkShow(this.students[newIdx].pic, newIdx)
    },
    initData() {
      this.$http
        .post('/api/v2/handwriting/BigScreen/get_class_student_works_list', {
          class_id: this.$route.query.class_id,
          student_id: this.$route.query.student_id,
        })
        .then((res) => {
          if (res.code == '200') {
            let list = res.data
            this.students = list || []
            this.loaded = true

            if (this.students.length > 0) {
              this.$nextTick(() => {
                this.$refs['bScroll'].addEventListener('scroll', (e) => {
                  this.scrollOffset = e.target.scrollTop
                })
              })
            }
          }
        })
    },
    picMarkShow(pic, index) {
      this.$refs['pic-mark'].show(pic, index)
    },
    scrollPrev(pref) {
      let pobj = this.$refs[pref]
      let ph = pobj.offsetHeight

      let targetY = 0
      if (this.scrollOffset <= ph) {
        targetY = 0
      } else {
        targetY = this.scrollOffset - ph
      }
      pobj.scrollTo(0, targetY)
      // scrollX(pobj,this.scrollOffset, targetX)
      this.scrollOffset = targetY
    },
    scrollNext(pref) {
      let pobj = this.$refs[pref]
      let ph = pobj.offsetHeight
      let sh = pobj.scrollHeight

      let targetY = 0
      if (this.scrollOffset + ph >= sh) {
        targetY = sh - ph
      } else {
        targetY = this.scrollOffset + ph
      }
      pobj.scrollTo(0, targetY)
      // scrollX(pobj,this.scrollOffset, targetX)
      this.scrollOffset = targetY
    },
  },
}
</script>
<style scoped>
.bScroll::-webkit-scrollbar {
  display: none;
}

.singInBg {
  background: #cfeeff;
}
.unSingInBg {
  background: #eeeeee;
}
.swiper-slide {
  flex-shrink: 1;
}

.loginContainer {
  width: 100vw;
  height: 100vh;
  background: url('../../assets/class_bg.png') no-repeat;
  background-size: 100% 100%;
}

.studentContainer {
  width: 80rem;
  height: calc(100vh - 10.4rem);
  padding: 0.5rem;
  margin: 0 auto;
  background: linear-gradient(
    to bottom right,
    rgba(255, 255, 255, 0.7) 0%,
    rgba(255, 255, 255, 0) 50%,
    rgba(255, 255, 255, 0.7) 100%
  );
  border-radius: 2rem;
}

.sendSmsBtn {
  cursor: pointer;
  width: 6.8rem;
  height: 2.4rem;
  line-height: 2.4rem;
  text-align: center;
  font-size: 1.4rem;
  border-radius: 1.2rem;
  color: #ffffff;
  background: linear-gradient(to right, #ffa143, #ffc11d);
}

.sendSmsBtn:hover {
  background: linear-gradient(to right, #f38b22, #f38b22);
}

.loginBtn {
  cursor: pointer;
  width: 6.8rem;
  height: 2.4rem;
  line-height: 2.4rem;
  text-align: center;
  font-size: 1.4rem;
  border-radius: 1.2rem;
  color: #ffffff;
  background: #2a9bff;
}

.loginBtn:hover {
  background: #158ffa;
}

.classContainer {
  width: 200%;
  position: absolute;
  top: 0;
  left: -50%;
  background: red;
  overflow: hidden;
  border-radius: 0 0 50% 50%;
  background: linear-gradient(
    0deg,
    rgba(15, 133, 219, 0.25) 0%,
    rgba(255, 255, 255, 0) 30%,
    rgba(255, 255, 255, 0) 100%
  );
}
</style>
